export const FILE_EXTENSIONS = {
  pdf: 'pdf',
  doc: 'doc',
  docx: 'docx',
  xlsx: 'xlsx',
  png: 'png',
  jpeg: 'jpeg',
  jpg: 'jpg',
};

export const SUCCESS_NOTIF_MSGS = {
  DELETED: 'File successfully deleted',
  MOVED: 'File successfully moved',
  RENAMED: 'File successfully renamed',
  UPLOADED: 'File successfully uploaded',
};

export const COLORS = {
  GREY: 'grey-7',
  BLUE: 'blue-6',
  TEAL: 'teal-6',
  RED: 'red-6',
};
